import {
    Box,
    BoxProps,
    ButtonProps,
    IconButton,
    Stack,
    Tooltip,
} from '@chakra-ui/react';
import { TermCategory } from '../../generated/types';
import getIconForCategoryKey from '../../utils/getIconForCategoryKey';
import React from 'react';
import getIconColorForCategoryKey from '../../utils/getIconColorForCategoryKey';

type SearchCategoryPickerProps = BoxProps & {
    categories: TermCategory[];
    activeCategory: TermCategory;
    onChangeCategory: (category: TermCategory) => void;
};

type SearchCategoryButtonProps = Omit<ButtonProps, 'onClick' | 'children'> & {
    category: TermCategory;
    isActive: boolean;
    onClick: (category: TermCategory) => void;
};

const SearchCategoryButton: React.FC<SearchCategoryButtonProps> = ({
    category,
    isActive,
    onClick,
    ...props
}) => {
    const clickHandler = () => onClick(category);
    const Icon = getIconForCategoryKey(category.key!);

    if (!Icon) return null;

    return (
        <Tooltip
            hasArrow
            label={category.name}
            aria-label={category.name}
            zIndex={9999}
            placement="top"
        >
            <IconButton
                aria-label={category.name}
                onClick={clickHandler}
                variant={isActive ? undefined : 'outline'}
                bg={
                    isActive
                        ? getIconColorForCategoryKey(category.key!)
                        : '#fff'
                }
                color={isActive ? '#fff' : undefined}
                _hover={{
                    bg: getIconColorForCategoryKey(category.key!),
                    color: '#fff',
                }}
                _active={
                    isActive
                        ? {
                              bg: getIconColorForCategoryKey(category.key!),
                              color: '#fff',
                          }
                        : undefined
                }
                flex="1"
                icon={<Icon />}
                {...props}
            />
        </Tooltip>
    );
};

const SearchCategoryPicker: React.FC<SearchCategoryPickerProps> = ({
    categories,
    activeCategory,
    onChangeCategory,
    ...props
}) => {
    // const onSelectCategory: ChangeEventHandler<HTMLSelectElement> = (e) => {
    //     const categoryId = e.target.value;

    //     const selectedCategory = categories.find(
    //         (category) => category.id === parseInt(categoryId, 10)
    //     );

    //     if (selectedCategory && selectedCategory.id !== activeCategory.id) {
    //         onChangeCategory(selectedCategory);
    //     }
    // };

    // return (
    //     <Flex align="center">
    //         <Box marginRight={3}>Was suchst Du?</Box>
    //         <Box flex={1}>
    //             <Select
    //                 value={activeCategory.id}
    //                 placeholder="Was suchst Du?"
    //                 onChange={onSelectCategory}
    //             >
    //                 {categories.map((category) => (
    //                     <option key={category.id} value={category.id}>
    //                         {category.labelPlural}
    //                     </option>
    //                 ))}
    //             </Select>
    //         </Box>
    //     </Flex>
    // );

    return (
        <Box {...props}>
            <Stack isInline spacing={1}>
                {categories.map((category) => (
                    <SearchCategoryButton
                        key={`SearchCategoryPicker_${category.id}`}
                        category={category}
                        onClick={onChangeCategory}
                        isActive={activeCategory.id === category.id}
                    />
                ))}

                {/* <TypeButton
                    label="Motorrad"
                    onClick={onChangeType}
                    icon={SearchType.motorcycle}
                    isActive={value === SearchType.motorcycle}
                />
                <TypeButton
                    label="eBike"
                    onClick={onChangeType}
                    icon={SearchType.ebike}
                    isActive={value === SearchType.ebike}
                />
                <TypeButton
                    label="Fahrrad"
                    onClick={onChangeType}
                    icon={SearchType.bike}
                    isActive={value === SearchType.bike}
                />
                <TypeButton
                    label="Wandern"
                    onClick={onChangeType}
                    icon={SearchType.hiking}
                    isActive={value === SearchType.hiking}
                />
                <TypeButton
                    label="Sehenswertes"
                    onClick={onChangeType}
                    icon={SearchType.poi}
                    isActive={value === SearchType.poi}
                /> */}
            </Stack>
        </Box>
    );
};

export default SearchCategoryPicker;
